var lib_core = require("lib-core");

var TrayModel = function (configuration) {
    lib_core.Model.call(this);

    this.visible = this.value("visible", true);
    this.visible(false);
    this.height = this.value("height", true);
    this.height(configuration.initial_height);
    this.minimum_height = configuration.minimum_height;
    this.initial_show = configuration.initial_show || false;
};
lib_core.inherit(TrayModel, lib_core.Model);
TrayModel.$class = "TrayModel";

module.exports = TrayModel;
